var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleDownRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 256C496 123.42 388.58 16 256 16S16 123.42 16 256C16 388.582 123.42 496 256 496S496 388.582 496 256ZM173.335 352.631C170.849 346.653 172.23 339.77 176.804 335.196L222.059 289.941L154.177 222.059C141.68 209.562 141.68 189.301 154.177 176.804L176.804 154.177C189.301 141.68 209.562 141.68 222.059 154.177L289.941 222.059L335.196 176.804C339.77 172.23 346.653 170.849 352.631 173.335C358.619 175.81 362.508 181.643 362.508 188.118V346.51C362.508 355.345 355.345 362.508 346.51 362.508H188.118C181.643 362.508 175.81 358.619 173.335 352.631Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDownRight);
export default __webpack_public_path__ + "static/media/circle-down-right.54b0ecb7d34947f207bcf3e477594b8c.svg";
export { ForwardRef as ReactComponent };